import React, {
  FC,
} from 'react';
import { FaChevronLeft } from 'react-icons/fa6';
import {
  Button, Column, Row,
} from './Styles';
import { Foodifox } from '../../../../assets/svg-image';

const Logo: FC<Props> = ({
  style,
  showBackIcon = true,
  showSubtitle = true,
  backToPage,
  setTargetPage,
  clearPlatform,
  onClose,
}) => {
  // 不需要返回箭头时
  if (!showBackIcon) {
    return (
      <Column style={{ ...style }}>
        <img src={Foodifox} style={{ width: '136px' }} />
      </Column>
    );
  }

  // 有返回箭头时
  return (
    <Row style={{ marginTop: '20px', justifyContent: 'space-between' }}>
      {/* 返回箭头 */}
      <Button
        style={{ marginLeft: '15px', marginTop: '-15px' }}
        onClick={() => {
          if (clearPlatform) {
            clearPlatform(undefined);
          }
          if (backToPage && setTargetPage) {
            setTargetPage(backToPage);
          }
          if (onClose) {
            onClose();
          }
        }}
      >
        <FaChevronLeft style={{ fontSize: '20px', marginTop: '7px', color: '#11202B' }} />
      </Button>
      {/* Logo */}
      <Column style={{ ...style }}>
        <img src={Foodifox} style={{ width: '136px' }} />
      </Column>
      {/* 用于和左侧返回箭头配合布局 */}
      <div style={{ width: '20px', marginRight: '25px', paddingRight: '1em' }} />
    </Row>
  );
};

export interface Props {
  style?: any;
  showBackIcon?: boolean;
  backToPage?: string;
  showSubtitle?: boolean;
  setTargetPage?: (targetPage: string) => void;
  clearPlatform?: (platform?: number) => void;
  onClose?: () => void;
}

export default Logo;
